{
  "archetype": "generic",
  "blockType": "hero-minimal",
  "contentHash": "a33b1635cedb84d357e019378ae7fbe9b3b89d937bfc5e621b659a903ceccb14",
  "description": "Clean minimal hero with large centered headline, one-line description, and a single prominent CTA. Maximum whitespace, no decorations.",
  "files": {
    "block": "block.cogo.json",
    "datasource": "datasource.cogo.json",
    "events": "events.cogo.json",
    "flow": "flow.cogo.json",
    "ui": "ui.cogo.json",
    "variables": "variables.cogo.json"
  },
  "generatedAt": "2026-04-25T02:24:03.525Z",
  "lifecycle": {
    "onMount": "heroMinimalMount"
  },
  "metadata": {
    "author": "cogo",
    "category": "hero",
    "id": "hero-minimal",
    "qualityTier": "golden",
    "tags": [
      "hero",
      "minimal",
      "clean",
      "centered",
      "landing",
      "simple"
    ]
  },
  "name": "hero-minimal",
  "permissions": {
    "forkable": true,
    "remixable": true,
    "visibility": "public"
  },
  "schemaVersion": "4.0",
  "socialMetadata": {
    "commentCount": 0,
    "fireCount": 0,
    "forkCount": 0
  },
  "stateContract": {
    "inputSymbols": [],
    "localState": {},
    "outputSymbols": []
  },
  "type": "ui",
  "version": "2.0.0"
}
